// extracted by mini-css-extract-plugin
export default {"richRender":"richRender_HFTNI"};